export function unwrapSupabaseJoin<T>(val: T | T[] | null | undefined): T | null {
    if (val === null || val === undefined) return null;
    return Array.isArray(val) ? val[0] ?? null : val;
}